import { render, staticRenderFns } from "./AktReviewDelegation.vue?vue&type=template&id=84a912ec"
import script from "./AktReviewDelegation.vue?vue&type=script&lang=ts"
export * from "./AktReviewDelegation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports